(function () {
    const DURATION_PER_DIGIT = 800;

    // Easing op de log-schaal van de waarde i.p.v. op de waarde zelf,
    // zodat elke decade vergelijkbare tijd krijgt (eerste cijfers niet
    // meer in een flits). In cijfer-tijd geeft dit een easeInOut gevoel:
    // momentum bouwt op door het midden en het einde landt zacht op
    // het target.
    function valueAt(progress, target) {
        if (progress >= 1) return target;
        if (progress <= 0 || target <= 0) return 0;
        const eased = 1 - Math.pow(1 - progress, 3);
        return Math.round(Math.pow(target + 1, eased) - 1);
    }

    function animateCounter(counter) {
        const target = parseInt(counter.dataset.target, 10) || 0;
        const eggs = [...counter.querySelectorAll('.egg-digit')];
        const length = eggs.length;
        const duration = DURATION_PER_DIGIT * length;
        const start = performance.now();

        function tick(now) {
            const progress = Math.min((now - start) / duration, 1);
            const value = valueAt(progress, target);
            const str = value > 0 ? String(value) : '';
            const startIndex = length - str.length;

            eggs.forEach((egg, i) => {
                const span = egg.querySelector('span');
                const isEmpty = i < startIndex;
                egg.classList.toggle('is-empty', isEmpty);
                const char = isEmpty ? '' : str[i - startIndex];
                if (span.textContent !== char) span.textContent = char;
            });

            if (progress < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
    }

    function initObserver() {
        const counters = document.querySelectorAll('.egg-counter[data-target]');
        if (!counters.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        animateCounter(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.5 }
        );

        counters.forEach((counter) => observer.observe(counter));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
    } else {
        initObserver();
    }
})();
